import axios from '@/lib/AxApi';

export default
{
    async getDashboardData(params)
    {
        try
        {
            const response = await axios.get('/Dashboard/getDashboardData',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
